import { Canvas } from "@craftjs/core";
import { UserMinus } from "lucide-react";

import { define } from "@/components/builder/utils";

import { UnsubscribeFormBlock, UnsubscribeFeedbackBlock, ConditionBlock, ConditionCaseBlock } from "..";
import BasePreview from "../base";

function UnsubscribePreview() {
  return <BasePreview>
    <div>
      <Canvas
        id="unsubscribe"
        is={ConditionBlock}
        properties={{ condition: 'unsubscribed', show: 'form' }}
        custom={{ state: { label: 'Page' } }}>
        <Canvas
          is={ConditionCaseBlock}
          custom={{ state: { name: 'Feedback', type: 'feedback' } }}>
          <Canvas
            is={UnsubscribeFeedbackBlock} />
        </Canvas>
        <Canvas
          is={ConditionCaseBlock}
          custom={{ state: { name: 'Form', type: 'form' } }}>
          <Canvas
            is={UnsubscribeFormBlock} />
        </Canvas>
      </Canvas>
    </div>
  </BasePreview>
}

function UnsubscribeHTML({ children }) {
  return <>
    {`{{#unsubscribe}}`}
    {children}
    {`{{/unsubscribe}}`}
  </>
}

export default define('unsubscribe', UnsubscribePreview, UnsubscribeHTML)
  .palete(<UserMinus size={20} />, 'Unsubscribe', 'Embedded')
  .canvas()
  .build()
